// Types
import type { SocialProfileType } from '@/types/socialProfileType';

// function that sort social profiles by active
export function sortProfilesByActive(profiles: SocialProfileType[]) {
    return [...profiles].sort((profile) => (profile.active ? -1 : 1));
}
